import { render, staticRenderFns } from "./projects-logger-page.html?vue&type=template&id=f2148fca&"
import script from "./projects-logger-page.js?vue&type=script&lang=js&"
export * from "./projects-logger-page.js?vue&type=script&lang=js&"
import style0 from "./projects-logger-page.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports